module.exports = __webpack_public_path__ + "img/bash-icon.2f552de0.png";